<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
        :active.sync="loading"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>
    <b-container fluid>
      
      <p class="text-left mt-1" style="color: #0069A9; font-weight: 600;">Actualización de precios masivo</p>
      <b-row>
        <b-col class="col-7">
          <b-form-group align="left">
            <label>Archivo</label>
            <b-form-file v-model="archivo" placeholder="Seleccionar archivo" browse-text="Abrir" type="file" @change="cargarArchivo($event)" :disabled="loadingProceso"
                         accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" ref="inputFile"></b-form-file>
            <b-form-text id="password-help-block">
              El archivo de carga de los precios debe tener los siguientes datos en el orden establecido (La columna correspondiente esta entre parentesis):

              <ul>
                <li>(A) Id zona *</li>
                <li>(B) Id_clinica *</li>
                <li>(C) Id tratamiento *</li>
                <li>(D) Precio</li>
                <li>(E) precio Extranjero</li>
                <li>(F) Bono individual *</li>
                <li>(G) Bono trimestral</li>
                <li>(H) Bono BE</li>
                <li>(I) Bono BE bono</li>
                <li>(J) Comisión OG</li>
              </ul>

              <p>* Si se especifica la clínica, se asume que es un precio especial para la clínica.</p>
              <br>
              <p><small>Nota: El archivo no debe tener ningun tipo de margen.
              </small></p>

              <a href="/files/formato-actualizar-precio.xlsx" download> Descargar Formato</a>

            </b-form-text>
          </b-form-group>
        </b-col>
        <b-col class="col-1">
              <b-button
              id="btn-vista"
              size="sm"
               class="mt-4"
               :disabled="loadingProceso"
              @click="limpiarFiltros()"
            >
              <b-icon icon="trash" v-b-tooltip.hover title="Limpiar Filtros"></b-icon>
            </b-button>
        </b-col>
        <b-col class="col-4"></b-col>
      </b-row>

      <b-row v-if="tratamientosInCorrectos.length > 0">
        <b-alert variant="danger" show style="width: 100%;margin: 0px;">
          Registros con errores {{tratamientosInCorrectos.length}}
          <b-icon icon="exclamation-circle" animation="cylon" style="color:#a71a1a"/>
        </b-alert>

        <b-table
            thead-tr-class="columnas"
            :items="tratamientosInCorrectos"
            :fields="fieldsError"
            responsive="true"
            striped
            sticky-header
            fixed></b-table>
      </b-row>

      <b-row v-if="tratamientosCorrectos.length > 0">
        <b-alert variant="primary" show  style="width: 100%;margin: 0px;">Registros para actualizar {{tratamientosCorrectos.length}}</b-alert>
        <b-table
            thead-tr-class="columnas"
            :items="tratamientosCorrectos"
            :fields="fields"
            responsive="true"
            striped
            sticky-header
            fixed></b-table>
      </b-row>
      <b-row>
        <b-col>
          <b-button variant="primary" @click="guardar" :disabled="loadingProceso || !(tratamientosCorrectos.length>0)">
            <span v-if="!loadingProceso">Actualizar {{tratamientosCorrectos.length}} registros
            </span>
            <span v-if="loadingProceso"><b-spinner small></b-spinner>Cargando...</span>
          </b-button>
        </b-col>
      </b-row>
      <br>
      <br>
    </b-container>
  </div>
</template>

<script>
import XLSX from 'xlsx'

export default {
  name: "altaPlanesMasivo",
  components: {
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      loadingTratamientos: false,
      loadingClinicas: false,
      loadingZona: false,
      loadingProceso: false,
      archivo: null,
      file: [],
      tratamientosCorrectos: [],
      tratamientosInCorrectos: [],
      fields: [
        { key: "rowNum", label: "Fila", sortable: true },
        { key: "estatusOperacion", label: "Estatus Operación", sortable: true },
        { key: "idZona", label: "Id Zona", sortable: true },
        { key: "nombreZona", label: "Zona", sortable: true },
        { key: "idClinica", label: "Id Clínica", sortable: true },
        { key: "nombreClinica", label: "Clínica", sortable: true },
        { key: "idTratamiento", label: "Id Tratamiento", sortable: true },
        { key: "nombreTratamiento", label: "Tratamiento", sortable: true },
      ],
      fieldsError: [],
      lstClinicas: [],
      lstTratamiento: [],
      lstZonas: [],
      idsTratamientos: [],
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  mounted() {
    this.llenarClinicas();
    this.llenarTratamientos();
    this.llenarZonas();
    this.obtenerTratamientosValidos();
    this.fields.push({ key: "precio", label: "Precio", sortable: true, formatter:this.$formatoMoneda });
    this.fields.push({ key: "precioExtranjero", label: "Precio Extranjero", sortable: true, formatter:this.$formatoMoneda});
    this.fields.push({ key: "bonoIndividualOg", label: "Bono Individual", sortable: true, formatter:this.$formatoMoneda });
    this.fields.push({ key: "bonoTrimestral", label: "Bono Trimestral", sortable: true, formatter:this.$formatoMoneda });
    this.fields.push({ key: "comisionBaseEspecialistas", label: "Comisión BE", sortable: true, formatter:this.$formatoMoneda });
    this.fields.push({ key: "comisionMasBonoEspecialistas", label: "Comisión BE Bono", sortable: true, formatter:this.$formatoMoneda });
    this.fields.push({ key: "comisionBaseOG", label: "Comisión OG", sortable: true, formatter:this.$formatoMoneda });

    this.fieldsError.push({ key: "motivoError", label: "Motivo Error", sortable: true})
    this.fieldsError.push(...this.fields);
    this.fieldsError.splice(1, 1);

  },
  computed: {
    loading() {
      return this.loadingTratamientos || this.loadingClinicas || this.loadingZona || this.loadingProceso
    }
  },
  methods: {
    llenarClinicas() {
      const url = this.$api + "catalogos/listaClinicasActivas";
      this.loadingClinicas = true;
      this.$http
          .post(url, {})
          .then((response) => {
            if (response.status === 200) {
              response.data.data.unshift({
                idClinica: null,
                strNombre: "Clinica :",
              });
              this.lstClinicas = response.data.data;
            }
          })
          .catch((err) => {
            this.showErroMsg(err);
          })
      .finally(()=>{this.loadingClinicas = false});
    },
    llenarTratamientos() {
      this.loadingTratamientos = true;
      const parametros = {idEspecialidad: 0, bandera: false}
      this.$http
          .post(this.$api + "tratamientos/obtenerTratamientos", parametros)
          .then((response) => {
              this.lstTratamiento = response.data.data
                  .map((it) => {
                    return {
                      idTratamiento: it.idTratamiento,
                      nombre: it.nombre
                    };
                  })
                  .filter(function (item) {
                    return item.ID != 0;
                  });
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.loadingTratamientos = false;
          });
    },
    llenarZonas() {
      this.loadingZona = true;
      this.$http.get(this.$api + "catalogos/listaPrecios").then(response => {
            if (response.data.data) {
              this.lstZonas = response.data.data
            }
          }
      ).finally(()=>{this.loadingZona = false});
    },
    obtenerTratamientosValidos(){
      this.loadingProceso = true;
      this.$http.post(this.$api + "tratamientos/obtenerTrtValidos").then((respuesta) => {
        this.idsTratamientos = respuesta.data.data;
      }).finally(()=> {
        this.loadingProceso = false;
      });
    },
    cargarArchivo(e) {
      this.loadingProceso = true;
      this.archivo=null;
      this.resultado = [];
      this.tratamientosCorrectos = [];
      this.tratamientosInCorrectos = [];
      const files = e.target.files;
      const fileReader = new FileReader(); // construction function that can read the file content
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary" // binary
          });
          const wsname = workbook.SheetNames[0]; //take the first sheet
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //Get the data in this table
          let lista = []

          lista = ws;

          lista.forEach(value => {

            const index = value["__rowNum__"] + 1;

            let nombreClinica = undefined;
            const clinicaT = this.lstClinicas.filter(it => it.idClinica === value["id_clinica"]);
            if (clinicaT.length > 0) {
              nombreClinica = clinicaT[0].strNombre;
            }

            let nombreTratamiento = undefined;
            const tratamientoT = this.lstTratamiento.filter(it => it.idTratamiento === value["id_tratamiento"]);
            if (tratamientoT.length > 0) {
              nombreTratamiento = tratamientoT[0].nombre;
            }

            let nombreZona = undefined;
            const zonaT = this.lstZonas.filter(it => it.idPrecio === value["id_zona"]);
            if (zonaT.length > 0) {
              nombreZona = zonaT[0].nombreZona;
            }

            if (nombreZona === undefined && nombreClinica !== undefined) {
              nombreZona = '';
            } else if (nombreZona !== undefined && nombreClinica === undefined) {
              nombreClinica = '';
            }

            let bonoIndividualOg;
            Number.isInteger(value["bono_individual"]) ? bonoIndividualOg = Number(value["bono_individual"]) : bonoIndividualOg = undefined;
            if(bonoIndividualOg == undefined){
              bonoIndividualOg = 0;
            }

            let bonoTrimestral;
            Number.isInteger(value["bono_trimestral"]) ? bonoTrimestral = Number(value["bono_trimestral"]) : bonoTrimestral = undefined;
            if(bonoTrimestral == undefined){
              bonoTrimestral = 0;
            }

            let comisionBaseEspecialistas;
            Number.isInteger(value["comision_be"]) ? comisionBaseEspecialistas = Number(value["comision_be"]) : comisionBaseEspecialistas = undefined;
            if(comisionBaseEspecialistas == undefined){
              comisionBaseEspecialistas = 0;
            }

            let comisionMasBonoEspecialistas;
            Number.isInteger(value["comision_be_bono"]) ? comisionMasBonoEspecialistas = Number(value["comision_be_bono"]) : comisionMasBonoEspecialistas = undefined;
            if(comisionMasBonoEspecialistas == undefined){
              comisionMasBonoEspecialistas = 0;
            }

            let comisionBaseOG;
            Number.isInteger(value["comision_og"]) ? comisionBaseOG = Number(value["comision_og"]) : comisionBaseOG = undefined;
            if(comisionBaseOG == undefined){
              comisionBaseOG = 0;
            }

            let precio;
            Number.isInteger(value["precio"]) ? precio = Number(value["precio"]) : precio = undefined;

            let precioExtranjero;
            Number.isInteger(value["precio_extranjero"]) ? precioExtranjero = Number(value["precio_extranjero"]) : precioExtranjero = undefined;

            const tratamiento = {
              rowNum: index,
              idClinica: value["id_clinica"],
              idTratamiento: value["id_tratamiento"],
              idZona: value["id_zona"],
              bonoIndividualOg: bonoIndividualOg,
              bonoTrimestral: bonoTrimestral,
              comisionBaseEspecialistas: comisionBaseEspecialistas,
              comisionMasBonoEspecialistas: comisionMasBonoEspecialistas,
              comisionBaseOG: comisionBaseOG,
              precio: precio,
              precioExtranjero: precioExtranjero,
              nombreClinica: nombreClinica,
              nombreTratamiento: nombreTratamiento,
              nombreZona: nombreZona,
              estatusOperacion: "Pendiente"
            }

           var precioNegativo = false
            if (precio < 0){
              precioNegativo = true;
            }

            var precioExtranjeroNegativo = false
            if (precioExtranjero < 0){
              precioExtranjeroNegativo = true;
            }

            var bonoIndividualOgNegativo = false
            if (bonoIndividualOg < 0){
              bonoIndividualOgNegativo = true;
            }

            var bonoTrimestralOgNegativo = false
            if (bonoTrimestral < 0){
              bonoTrimestralOgNegativo = true;
            }

            var comisionBaseEspecialistasNegativo = false
            if (comisionBaseEspecialistas < 0){
              comisionBaseEspecialistasNegativo = true;
            }

            var comisionMasBonoEspecialistasNegativo = false
            if (comisionBaseEspecialistas < 0){
              comisionMasBonoEspecialistasNegativo = true;
            }

            var comisionBaseOGNegativo = false
            if (comisionBaseEspecialistas < 0){
              comisionBaseOGNegativo = true;
            }

            var tratamientoViejo = true
            this.idsTratamientos.forEach(id => {
              if(id.idTratamiento == value["id_tratamiento"]){
                tratamientoViejo = false
              }
            });

            if (nombreTratamiento === undefined
                || nombreZona === undefined
                || nombreClinica === undefined
                || bonoIndividualOg === undefined
                || bonoTrimestral === undefined
                || comisionBaseEspecialistas === undefined
                || comisionMasBonoEspecialistas === undefined
                || comisionBaseOG === undefined
                || precio === undefined
                || precioExtranjero === undefined
                || precioNegativo === true
                || precioExtranjeroNegativo === true
                || bonoIndividualOgNegativo === true
                || bonoTrimestralOgNegativo === true
                || comisionBaseEspecialistasNegativo === true 
                || comisionMasBonoEspecialistas === true 
                || comisionBaseOGNegativo 
                || tratamientoViejo) {

              let motivo = [];
              if (precioNegativo) {
                motivo.push("Precio Negativo")
              }
              if (precioExtranjeroNegativo) {
                motivo.push("Precio Extranjero Negativo")
              }
              if (bonoIndividualOgNegativo) {
                motivo.push("Bono individual Negativo")
              }
              if (bonoTrimestralOgNegativo) {
                motivo.push("Bono trimestral Negativo")
              }
              if (comisionBaseEspecialistasNegativo) {
                motivo.push("Comisión BE Negativo")
              }
              if (comisionMasBonoEspecialistasNegativo) {
                motivo.push("Comisión BE Bono Negativo")
              }
              if (comisionBaseOGNegativo) {
                motivo.push("Comisión OG Negativo")
              }
              if (nombreTratamiento === undefined) {
                motivo.push("Tratamiento no encontrado")
              }
              if (nombreZona === undefined) {
                motivo.push("Zona no encontrada")
              }
              if (nombreClinica === undefined) {
                motivo.push("Clínica no encontrada")
              }
              if (bonoIndividualOg === undefined) {
                motivo.push("Bono individual sin dato")
              }
              if (bonoTrimestral === undefined) {
                motivo.push("Bono trimestral sin dato")
              }
              if (comisionBaseEspecialistas === undefined) {
                motivo.push("Comisión BE sin dato")
              }
              if (comisionMasBonoEspecialistas === undefined) {
                motivo.push("Comisión BE Bono sin dato")
              }
              if (comisionBaseOG === undefined) {
                motivo.push("Comisión OG sin dato")
              }
              if (precio === undefined) {
                motivo.push("Precio sin dato")
              }
              if (precioExtranjero === undefined) {
                motivo.push("Precio extranjero sin dato")
              }
              if (tratamientoViejo && nombreTratamiento !== undefined) {
                motivo.push("El tratamiento no es actual")
              }
              tratamiento.motivoError = motivo;
              this.tratamientosInCorrectos.push(tratamiento);
            } else {
              this.tratamientosCorrectos.push(tratamiento);
            }
          });

        } catch (e) {
          this.loadingProceso = false;
          console.error(e);
        }
        this.loadingProceso = false;
      };
      fileReader.readAsBinaryString(files[0]);
    },
    guardar(){
      this.loadingProceso = true;
      this.$http.post(this.$api + "tratamientos/guardarActualizacionPrecio", this.tratamientosCorrectos)
          .then((respuesta) => {
        if (respuesta.data.data) {
          this.tratamientosCorrectos = respuesta.data.data;
          this.$swal.fire({
            icon: "success",
            title: "Aviso",
            html:'<p>Los precios de los tratamientos se actualizaron correctamente:</p>' +
                '<br>' +
                '<p><label>Tratamientos actualizados: </label><span>'+this.tratamientosCorrectos.filter(it=>it.estatusOperacion==='Actualizado').length+' </span></p>'+
                '<p><label>Tratamientos con error: </label><span>'+this.tratamientosCorrectos.filter(it=>it.estatusOperacion!=='Actualizado').length+' </span></p>'
          });
          this.archivo = null;
        }
      }).finally(()=> {
        this.loadingProceso = false;
      });
    },
    limpiarFiltros(){
      this.archivo=null;
      this.resultado = [];
      this.tratamientosCorrectos = [];
      this.tratamientosInCorrectos = [];
      this.$refs.inputFile.reset();
    },
  }
}
</script>

<style scoped>
</style>
